module.exports = __webpack_public_path__ + "static/media/ep_mur_mitoyen.75b18e3d.jpg";